import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { ThemeProvider } from "styled-components";
import darkTheme from "./utils/theme";
import { useContext, useEffect } from "react";
import { ProductContext } from "./context/ProductContext";
import { AuthUserProvider } from "./context/AuthUserContext";
import { HelmetProvider } from "react-helmet-async";
import Product from "./pages/Product";
import Shop from "./pages/Shop";
import Account from "./pages/account/Account";
import ProtectedRoute, {
  ProtectedRouteVerification,
  ProtectedRouteSignUpIn,
  ProtectedRouteVerificationAndAdmin,
  ProtectedAdmin,
} from "./ProtectedRoute";
import Checkout from "./pages/Checkout";
import BestSeller from "./pages/product/BestSeller";
import ThankYou from "./pages/ThankYou";
import Register from "./pages/account/Register";
import PasswordReset from "./layouts/main/account/ResetPassword";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import ScrollToTop from "./utils/ScrollToTop";
import Brands from "./pages/Brands";
import NewArrivals from "./pages/product/NewArrivals";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SubscriptionPopup from "./components/popup/SubscriptionPopup";
import Login from "./components/popup/Login";
import SimpleContext from "./context/SimpleContext";
import Verification from "./components/popup/Verification";
import ReturnAndRefundPolicy from "./pages/legal/ReturnAndRefundPolicy";
import TermsConditions from "./pages/legal/TermsConditions";
import Error404 from "./pages/Error404";

function App() {
  const { loadBrands, brands } = useContext(ProductContext);
  const { showLogin, showVerification } = useContext(SimpleContext);

  useEffect(() => {
    if (!brands || !brands.length) {
      loadBrands();
    }
  }, []);

  return (
    <>
      <HelmetProvider>
        <ThemeProvider theme={darkTheme}>
          <BrowserRouter>
            <AuthUserProvider>
              {showLogin && <Login />}
              {showVerification && <Verification />}
              {/* <SubscriptionPopup /> */}
              <ScrollToTop />
              <ToastContainer style={{ zIndex: "999999" }} />
              <Routes>
                <Route element={<ProtectedAdmin />}>
                  <Route
                    path="/:lang/signup"
                    element={
                      <ProtectedRouteSignUpIn>
                        <Register />
                      </ProtectedRouteSignUpIn>
                    }
                  ></Route>
                  <Route path="/:lang?" element={<Home />}></Route>
                  <Route
                    path="/:lang/unsere-marken"
                    element={<Brands />}
                  ></Route>
                  <Route path="/:lang/:slug" element={<Product />} />
                  <Route
                    path="/:lang/snus-verkauf/:slug?"
                    element={<Shop />}
                  ></Route>
                  <Route path="/:lang/best-seller" element={<BestSeller />} />
                  <Route path="/:lang/new-arrivals" element={<NewArrivals />} />

                  <Route
                    path="/:lang/reset-password/:uid/:token/"
                    element={
                      <ProtectedRouteSignUpIn>
                        <PasswordReset />
                      </ProtectedRouteSignUpIn>
                    }
                  />

                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route
                    path="/return-and-refund-policy"
                    element={<ReturnAndRefundPolicy />}
                  />
                  <Route
                    path="/terms-conditions"
                    element={<TermsConditions />}
                  />

                  <Route
                    path="/:lang/checkout"
                    element={
                      <ProtectedRoute>
                        <ProtectedRouteVerificationAndAdmin>
                          <Checkout />
                        </ProtectedRouteVerificationAndAdmin>
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/:lang/thank-you" element={<ThankYou />} />

                  {/* Account */}
                  <Route
                    path="/:lang/account"
                    element={
                      <ProtectedRoute>
                        <ProtectedRouteVerification>
                          <Account />
                        </ProtectedRouteVerification>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/:lang/account/profile"
                    element={
                      <ProtectedRoute>
                        <ProtectedRouteVerification>
                          <Account />
                        </ProtectedRouteVerification>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/:lang/account/address-book"
                    element={
                      <ProtectedRoute>
                        <ProtectedRouteVerification>
                          <Account />
                        </ProtectedRouteVerification>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/:lang/account/orders"
                    element={
                      <ProtectedRoute>
                        <ProtectedRouteVerification>
                          <Account />
                        </ProtectedRouteVerification>
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/:lang/account/address-book/new"
                    element={
                      <ProtectedRoute>
                        <ProtectedRouteVerification>
                          <Account />
                        </ProtectedRouteVerification>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/:lang/account/address-book/edit/:id"
                    element={
                      <ProtectedRoute>
                        <ProtectedRouteVerification>
                          <Account />
                        </ProtectedRouteVerification>
                      </ProtectedRoute>
                    }
                  />
                </Route>
                <Route path="/404" element={<Error404 />} />
                <Route path="*" element={<Error404 />} />
              </Routes>
            </AuthUserProvider>
          </BrowserRouter>
        </ThemeProvider>
      </HelmetProvider>
    </>
  );
}

export default App;
